module.exports = __webpack_public_path__ + "static/media/occupation_detail.e7a39dd1.svg";